$(document).on("click", "*[data-academia-share]", function (e) {
  var view;
  view = new AcademiaSharing.BookmarkButtonView({
    el: $(e.currentTarget)
  });
  return view.model.fetch().error(function () {
    return view.model.set({
      message: ''
    });
  }).always(function () {
    return view.handle_bookmark_click();
  });
});